import { IMediaFile } from 'components/Design/UploadsTab/Types'
import { isVideo } from 'components/ImagePickerModal/utils'
import { useField } from 'formik'
import { MediaVariant } from 'types'

export const useImageWithBackgroundVariant = (media: IMediaFile | undefined) => {
  const [removeBackground] = useField<boolean>('initial_media_file_remove_background')

  const removedBackgroundVariant = media?.variants?.find(
    (v) => !!v.transformations.remove_background && !!v.source_url,
  ) as MediaVariant | undefined

  const imageUrl =
    !!removedBackgroundVariant && removeBackground.value
      ? removedBackgroundVariant.source_url
      : media?.thumbnail_url || media?.source_url

  const video = isVideo({ url: media?.source_url, type: media?.mime_type })
  const videoUrl = video ? media?.source_url : undefined

  return {
    removedBackgroundVariant,
    imageUrl,
    videoUrl,
  }
}
